import React from 'react';

// Simplified geometric SVG flags (30x20 viewBox), recognizable at small sizes.
const FLAGS = {
  // United States
  en: (
    <>
      <rect width="30" height="20" fill="#FFFFFF" />
      {[0, 4, 8, 12, 16].map((y) => (
        <rect key={y} y={y} width="30" height="2" fill="#B22234" />
      ))}
      <rect width="12" height="10" fill="#3C3B6E" />
    </>
  ),
  // Germany
  de: (
    <>
      <rect width="30" height="6.67" fill="#000000" />
      <rect y="6.67" width="30" height="6.67" fill="#DD0000" />
      <rect y="13.33" width="30" height="6.67" fill="#FFCE00" />
    </>
  ),
  // Spain
  es: (
    <>
      <rect width="30" height="5" fill="#AA151B" />
      <rect y="5" width="30" height="10" fill="#F1BF00" />
      <rect y="15" width="30" height="5" fill="#AA151B" />
    </>
  ),
  // Portugal
  pt: (
    <>
      <rect width="12" height="20" fill="#046A38" />
      <rect x="12" width="18" height="20" fill="#DA291C" />
      <circle cx="13" cy="10" r="5" fill="#FFE900" />
    </>
  ),
  // Italy
  it: (
    <>
      <rect width="10" height="20" fill="#009246" />
      <rect x="10" width="10" height="20" fill="#F1F2F1" />
      <rect x="20" width="10" height="20" fill="#CE2B37" />
    </>
  ),
  // France
  fr: (
    <>
      <rect width="10" height="20" fill="#0055A4" />
      <rect x="10" width="10" height="20" fill="#FFFFFF" />
      <rect x="20" width="10" height="20" fill="#EF4135" />
    </>
  ),
  // Japan
  ja: (
    <>
      <rect width="30" height="20" fill="#FFFFFF" />
      <circle cx="15" cy="10" r="6" fill="#BC002D" />
    </>
  ),
  // China
  zh: (
    <>
      <rect width="30" height="20" fill="#DE2910" />
      <path
        d="M4 0.9 L4.5878 2.691 L6.4727 2.6966 L4.9511 3.809 L5.5283 5.6034 L4 4.5 L2.4717 5.6034 L3.0489 3.809 L1.5273 2.6966 L3.4122 2.691 Z"
        fill="#FFDE00"
      />
    </>
  ),
  // Russia
  ru: (
    <>
      <rect width="30" height="6.67" fill="#FFFFFF" />
      <rect y="6.67" width="30" height="6.67" fill="#0039A6" />
      <rect y="13.33" width="30" height="6.67" fill="#D52B1E" />
    </>
  ),
};

export default function LanguageFlag({ code, size = 16 }) {
  const flag = FLAGS[code];
  if (!flag) {
    return null;
  }
  return (
    <svg
      viewBox="0 0 30 20"
      width={size}
      height={(size * 20) / 30}
      style={{ borderRadius: 2, boxShadow: '0 0 0 1px rgba(0, 0, 0, 0.12)' }}
      aria-hidden="true"
    >
      {flag}
    </svg>
  );
}
